import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSubscription } from "src/context/SubscriptionProvider";
import WhiteCard from "src/shared/components/WhiteCard";

const PlanInfo = () => {
  const glp1Subscription = useSubscription((s) => s.product.is_glp1);
  const subscriptionProduct = useSubscription((s) => s.product.display_name);
  const duration = useSubscription((s) => s.price.number_of_months);
  const { t } = useTranslation();
  const page = "cancellationReview";

  const medication = useMemo(() => {
    if (glp1Subscription) {
      return t(`${page}.glp1`, "GLP-1 injections");
    }

    return t(`${page}.medication.${subscriptionProduct}`);
  }, [glp1Subscription, subscriptionProduct, t]);

  const plan = useMemo(() => {
    return t(`${page}.duration`, "{{duration}} month plan", { duration });
  }, [duration, t]);

  return (
    <WhiteCard>
      <Stack gap={1}>
        <Typography variant="subtitle1">
          {t(`medication.capitalized`, "Medication")}
        </Typography>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Typography>{medication}</Typography>
          <Typography>{plan}</Typography>
        </Stack>
      </Stack>
    </WhiteCard>
  );
};

export default PlanInfo;
